import React from 'react';
import {
  SummaryWrapper,
  SummaryTitle,
  KPIGrid,
  KPICard,
  KPILabel,
  KPINumber,
  InfoList,
  InfoItem,
  GPACard,
  ProgressBar,
} from './AcademicSummary.styles';

const AcademicSummary: React.FC = () => {
  return (
    <SummaryWrapper>
      <SummaryTitle>
        <span role="img" aria-label="mortar">🎓</span> Academic Summary
      </SummaryTitle>
      <GPACard>
        <div style={{ fontSize: '2.2rem', lineHeight: 1 }}>3.72</div>
        <div style={{ opacity: 0.9 }}>Overall GPA</div>
      </GPACard>
      <KPIGrid>
        <KPICard>
          <KPINumber>3.85</KPINumber>
          <KPILabel>Major GPA</KPILabel>
        </KPICard>
        <KPICard>
          <KPINumber>4</KPINumber>
          <KPILabel>Dean's List</KPILabel>
        </KPICard>
      </KPIGrid>
      <div style={{ fontSize: '0.9rem', color: '#6B7280', marginBottom: 6 }}>Credits Progress <span style={{ float: 'right', color: '#223046' }}>78/120</span></div>
      <ProgressBar>
        <div style={{ width: '65%' }} />
      </ProgressBar>
      <div style={{ height: 10 }} />
      <InfoList>
        <InfoItem>
          <div style={{ color: '#6B7280', fontSize: '0.95rem' }}>Current Standing</div>
          <div style={{ marginTop: 4 }}>
            <span style={{ background: '#E9EEF5', color: '#223046', borderRadius: 14, padding: '2px 10px', fontWeight: 700, fontSize: '0.85rem' }}>Junior</span>
          </div>
        </InfoItem>
        <InfoItem>
          <div style={{ color: '#6B7280', fontSize: '0.95rem' }}>Expected Graduation</div>
          <div style={{ marginTop: 4, fontWeight: 700 }}>Spring 2026</div>
        </InfoItem>
      </InfoList>
    </SummaryWrapper>
  );
};

export default AcademicSummary;


